var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { defaultAvatarProps } from './props';
import * as Styles from './styles';
/**
 * Componente Avatar do Design System OLX
 */
export const Avatar = forwardRef((_a, ref) => {
    var { size, src, alt, dsParentName } = _a, rest = __rest(_a, ["size", "src", "alt", "dsParentName"]);
    return (React.createElement(Styles.AvatarWrapper, Object.assign({ "data-ds-component": dsParentName ? `DS-${dsParentName}-Avatar` : 'DS-Avatar', src: src ? src : defaultAvatarProps.src, size: size, alt: alt ? alt : '' }, rest, { ref: ref })));
});
Avatar.displayName = 'Avatar';
